import { $ } from 'utils/dom';

const livestream = $('.livestream-header');
if (livestream) {
  const startDate = new Date(livestream.dataset.starttime);
  const endDate = livestream.dataset.endtime
    ? new Date(livestream.dataset.endtime)
    : null;

  const checkLivestreamDate = () => {
    const nowDate = new Date();
    const streamIsLive = nowDate > startDate;
    // if stream is live, show livestream
    if (streamIsLive) {
      // if endDate was set and livestream time is beyond endDate, also active livestream
      if (endDate) {
        if (nowDate < endDate) {
          livestream.classList.add('is-live');
        } else {
          livestream.classList.add('was-live');
          livestream.classList.remove('is-live');
        }
      } else {
        livestream.classList.add('is-live');
      }
    }
  };

  checkLivestreamDate();
  setInterval(() => {
    checkLivestreamDate();
  }, 1000);
}
